import { AuthRepository } from "../repositories/AuthRepository";
import { LoginCredentials, AuthResultEntity } from "../entities/AuthResult";

/**
 * Login Use Case
 */
export class LoginUseCase {
  constructor(private repository: AuthRepository) {}

  async execute(credentials: LoginCredentials): Promise<AuthResultEntity> {
    if (!credentials.email || !credentials.email.trim()) {
      throw new Error("Email is required");
    }

    if (!credentials.password || !credentials.password.trim()) {
      throw new Error("Password is required");
    }

    return await this.repository.login(credentials);
  }
}

